import React, { useCallback, useState } from "react";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";
import isEmpty from "../../../store/validation/is-Empty";
import {
  TextField,
  FormHelperText,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  IconButton,
  OutlinedInput,
  InputAdornment,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
// import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { useEffect } from "react";

const theme = createTheme({
    overrides: {
      PrivateNotchedOutline: {
        legend: {
          width: "265px !important",
        },
      },
    },
  });


export const InputBox = ({
    extraClass,
    labelWidth,
    name,
    inputType,
    helpTextDisplay,
    helperTextBottom,
    autoComplete,
    autoFocus,
    onChange,
    value,
    min,
    max,
    maxLength,
    onFocusOut,
    onKeyUp,
    onKeyDown,
    controlClass,
    labelText,
    multiline,
    rows,
    errorTrue,
    errorText,
    disabled,
    isInvalid,
    onBlur,
    onInput,
    placeholder,
    onKeyPress,
    InputLabelProps,
    onpaste,
    required,
    // inputProps,
  }) => {
    const [focus, setFocus] = useState(false);
    return (
      <React.Fragment>
        <div
          className={`input_Box_margin ${extraClass ? extraClass : ""} ${
            (value || focus) && `mobile-view-width-border-spacing-textfield`
          }`}
        >
          <ThemeProvider theme={labelText && theme}>
            <TextField
              error={errorTrue ? true : false}
              fullWidth
              placeholder={placeholder}
              id={controlClass}
              type={inputType ? inputType : ""}
              autoComplete={autoComplete}
              autoFocus={autoFocus}
              name={name}
              label={labelText ? labelText : ""}
              key={labelText}
              value={value}
              onChange={onChange}
              helperText={errorText}
              variant="outlined"
              min={min}
              max={max}
              onFocus={() => setFocus(true)}
              inputProps={{ maxLength: maxLength }}
              // InputProps={{ inputProps: inputProps }}
              onBlur={(e) => {
                setFocus(false);
                if (onFocusOut) {
                  onFocusOut(e);
                }
              }}
              onKeyUp={onKeyUp}
              onKeyPress={onKeyPress}
              onKeyDown={onKeyDown}
              multiline={multiline ? true : false}
              rows={rows}
              disabled={disabled === true ? true : false}
              onInput={onInput}
              shrink
              InputLabelProps={
                (inputType === "date" || inputType === "time") && { shrink: true }
              }
              onPaste={onpaste}
              required={required}
            />{" "}
          </ThemeProvider>
          {helpTextDisplay ? (
            <FormHelperText id="component-helper-text">
              {helperTextBottom}
            </FormHelperText>
          ) : null}
        </div>
      </React.Fragment>
    );
  }